import React from "react";

import { GridItem, GridRow } from "commons/ui/Grid";
import Select from "commons/ui/input/Select";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { ShowroomListHook } from "hooks/list/useShowroomList";

function ShowroomExtraFilters({ showroomListHook }: { showroomListHook: ShowroomListHook }) {
    const { staticFilterHook, continentGroup } = showroomListHook;

    const { setValue, form } = staticFilterHook;

    return (
        <GridRow>
            <GridItem className={"col-xs-12-4"}>
                <Select
                    label={"Area geografica"}
                    options={[{ value: "", label: "Tutte" }, ...continentGroup]}
                    value={form.group_id}
                    path={"group_id"}
                    setValue={setValue}
                    showPlaceholder
                />
            </GridItem>

            <GridItem className={"col-xs-12-4"}>
                <Select
                    label={"Area pubblica"}
                    options={[
                        { value: "", label: "Tutti" },
                        { value: true, label: "Visibile" },
                        { value: false, label: "Non visibile" },
                    ]}
                    placeholder={"Tutti"}
                    value={form.enabled}
                    path={"enabled"}
                    setValue={setValue}
                    showPlaceholder
                />
            </GridItem>
        </GridRow>
    );
}

function ShowroomTableFilters({ showroomListHook }: { showroomListHook: ShowroomListHook }) {
    const { onSearchFilterChange, staticFilterHook, filterSearchHook } = showroomListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    const { clearStaticFilters } = staticFilterHook;

    const clearAllFilters = React.useCallback(() => {
        clearFilters();
        clearStaticFilters();
    }, [clearStaticFilters, clearFilters]);

    return (
        <FiltersContainer
            applyFilters={applyFilters}
            clearFilters={clearAllFilters}
            extraFilters={<ShowroomExtraFilters showroomListHook={showroomListHook} />}
            openDefault={staticFilterHook.filters.length > 0}
        >
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.title}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default ShowroomTableFilters;
